module.exports = __webpack_public_path__ + "static/img/odk-min.92671306.png";